"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["CREDIT"] = "credit";
    OrderType["BUYOUT"] = "buyout";
    OrderType["EXCHANGE"] = "exchange";
    OrderType["INSTALLMENT"] = "installment";
    OrderType["CALL_REQUEST"] = "call_request";
    OrderType["CATALOG_ORDER"] = "catalog_order";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
